export default __webpack_public_path__ + "static/media/rect.c210fa46.svg";